package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** תגובה ממוספרת של התראות פעילות - תואמת ל-PaginatedResponse של ה-API */
@Serializable
data class ActivityNotificationsPageResponse(
    @SerialName("status") val status: Boolean = true,
    @SerialName("message") val message: String? = null,
    @SerialName("data") val data: List<ActivityNotificationDto>? = null,
    @SerialName("pagination") val pagination: PaginationDto? = null
)
// PaginationDto מוגדר ב-UserDto.kt

@Serializable
data class ActivityNotificationDto(
    @SerialName("id") val id: Int,
    @SerialName("type") val type: String,
    @SerialName("from_user") val fromUser: UserDto,
    @SerialName("post") val post: PostDtoV2? = null,
    @SerialName("comment") val comment: CommentDto? = null,
    @SerialName("data_id") val dataId: Int? = null,
    @SerialName("is_read") val isRead: Boolean = false,
    @SerialName("created_at") val createdAt: String
)

@Serializable
data class AdminNotificationDto(
    @SerialName("id") val id: Int,
    @SerialName("title") val title: String,
    @SerialName("message") val message: String,
    @SerialName("image_url") val imageUrl: String? = null,
    @SerialName("action_url") val actionUrl: String? = null,
    @SerialName("is_read") val isRead: Int = 0,
    @SerialName("created_at") val createdAt: String
)

/** Unified feed item (activity or admin) - GET /notifications */
@Serializable
data class UnifiedNotificationPageResponse(
    @SerialName("status") val status: Boolean = true,
    @SerialName("message") val message: String? = null,
    @SerialName("data") val data: List<UnifiedNotificationItemDto>? = null,
    @SerialName("pagination") val pagination: PaginationDto? = null
)

@Serializable
data class UnifiedNotificationItemDto(
    @SerialName("type") val type: String,
    @SerialName("id") val id: Int,
    @SerialName("is_read") val isRead: Boolean = false,
    @SerialName("created_at") val createdAt: String,
    @SerialName("from_user_id") val fromUserId: Int? = null,
    @SerialName("from_user") val fromUser: UserDto? = null,
    @SerialName("to_user_id") val toUserId: Int? = null,
    @SerialName("data_id") val dataId: Int? = null,
    @SerialName("notification_type") val notificationType: String? = null,
    @SerialName("admin_notification_id") val adminNotificationId: Int? = null,
    @SerialName("title") val title: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("post") val post: PostDtoV2? = null,
    @SerialName("comment") val comment: CommentDto? = null
)
